export default __webpack_public_path__ + "static/media/Webinar_El_valor_de_la_postventa_es_la_venta_final.1a637639.pdf";